import { render, staticRenderFns } from "./app-radio-button.vue?vue&type=template&id=af24bd38&scoped=true&"
import script from "./app-radio-button.vue?vue&type=script&lang=js&"
export * from "./app-radio-button.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "af24bd38",
  null
  ,true
)

export default component.exports